import { injectable, inject } from 'inversify'

import { RoutingService } from '#AltServices'

@injectable()
export class UsersRoutingService {
  constructor(@inject(RoutingService) readonly router: RoutingService) {}

  get profileEdit() {
    return this.router.createRouteData({ name: 'ProfileEdit' })
  }
}
